"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.sort.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.starts-with.js");
require("core-js/modules/es.string.trim.js");
var _login = require("@/api/login");
var _auth = require("@/utils/auth");
var _cloud = require("@/utils/cloud");
var _jsencrypt = require("@/utils/jsencrypt");
var userInfoObject = {
  state: {
    token: (0, _auth.getToken)(),
    name: '',
    avatar: '',
    roles: [],
    permissions: []
  },
  mutations: {
    SET_TOKEN: function SET_TOKEN(state, token) {
      state.token = token;
    },
    SET_NAME: function SET_NAME(state, name) {
      state.name = name;
    },
    SET_AVATAR: function SET_AVATAR(state, avatar) {
      state.avatar = avatar;
    },
    SET_ROLES: function SET_ROLES(state, roles) {
      state.roles = roles;
    },
    SET_PERMISSIONS: function SET_PERMISSIONS(state, permissions) {
      state.permissions = permissions;
    }
  },
  actions: {
    // 登录
    Login: function Login(_ref, userInfo) {
      var commit = _ref.commit;
      var username = userInfo.username.trim();
      var password = (0, _jsencrypt.encrypt)(userInfo.password);
      var code = userInfo.code;
      var uuid = userInfo.uuid;
      var tenantId = userInfo.tenantId;
      return new Promise(function (resolve, reject) {
        (0, _login.login)(username, password, code, uuid, tenantId).then(function (res) {
          (0, _auth.setToken)(res.token);
          commit('SET_TOKEN', res.token);
          resolve(res);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    // 短信登录
    TelLogin: function TelLogin(_ref2, userInfo) {
      var commit = _ref2.commit;
      var username = userInfo.username.trim();
      var password = userInfo.password;
      var code = userInfo.code;
      var uuid = userInfo.uuid;
      var telephone = userInfo.telephone;
      var tenantId = userInfo.tenantId;
      return new Promise(function (resolve, reject) {
        (0, _login.telLogin)(username, password, code, uuid, telephone, tenantId).then(function (res) {
          (0, _auth.setToken)(res.token);
          commit('SET_TOKEN', res.token);
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    // 获取用户信息
    GetInfo: function GetInfo(_ref3) {
      var commit = _ref3.commit,
        state = _ref3.state;
      return new Promise(function (resolve, reject) {
        (0, _login.getInfo)(state.token).then(function (res) {
          sessionStorage.setItem('userInfo', JSON.stringify(res.user));
          var permissions = res.permissions.sort();
          // console.log(permissions)
          var user = res.user;
          var avatarTemp = require('@/assets/image/profile.jpg');
          if (user.avatar !== '') {
            var _user$avatar;
            if ((_user$avatar = user.avatar) !== null && _user$avatar !== void 0 && _user$avatar.startsWith('http')) {
              avatarTemp = user.avatar;
            } else {
              avatarTemp = process.env.VUE_APP_BASE_API + _cloud.urls.user + user.avatar;
            }
          }
          var avatar = avatarTemp;
          if (res.roles && res.roles.length > 0) {
            // 验证返回的roles是否是一个非空数组
            commit('SET_ROLES', res.roles);
            commit('SET_PERMISSIONS', permissions);
          } else {
            commit('SET_ROLES', ['ROLE_DEFAULT']);
          }
          commit('SET_NAME', user.username);
          commit('SET_AVATAR', avatar);
          resolve(res);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    ChangeToken: function ChangeToken(_ref4, token) {
      var commit = _ref4.commit;
      return new Promise(function (resolve /* , reject */) {
        (0, _auth.setToken)(token);
        commit('SET_TOKEN', token);
        resolve();
      });
    },
    // 退出系统
    LogOut: function LogOut(_ref5) {
      var commit = _ref5.commit,
        state = _ref5.state;
      return new Promise(function (resolve, reject) {
        (0, _login.logout)(state.token).then(function () {
          commit('SET_TOKEN', '');
          commit('SET_ROLES', []);
          commit('SET_PERMISSIONS', []);
          (0, _auth.removeToken)();
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    // 前端 登出
    FedLogOut: function FedLogOut(_ref6) {
      var commit = _ref6.commit;
      return new Promise(function (resolve) {
        commit('SET_TOKEN', '');
        (0, _auth.removeToken)();
        resolve();
      });
    }
  }
};
var _default = exports.default = userInfoObject;